(function () {
    "use strict";


    // @ngInject
    function ViewLoggingServiceCtor($injector, $q, _,Routes, NetworkManager) {
        this.$q = $q;
        this.Routes = Routes;
        this.$injector = $injector;
        this._ = _;
        this.NetworkManager = NetworkManager;
        this.initialize();
        this._oppsViewedLocal = [];
        this.sendOppsViewedDeboune = _.debounce(this.sendOppsViewed.bind(this), 3000);
    }

    Services.ViewLoggingService = Class(function () {
        return {
            constructor: ViewLoggingServiceCtor,

            initialize: function initialize(){
            },

            viewOpportunity: function viewOpportunity(opp) {

                this._oppsViewedLocal.push(opp._id);
                this.sendOppsViewedDeboune();
            },

            sendOppsViewed: function sendOppsViewed(){
                var ids = angular.copy(this._oppsViewedLocal);
                this._oppsViewedLocal = [];
                this.NetworkManager.sendViewOpportunitiesByIds(ids);
            }
        };
    });
}());
